module.exports = __webpack_public_path__ + "static/media/investor-scout-3-logo-full.295e6da2.svg";